﻿import {useGeocoder} from "./useGeocoder";
import {useEffect, useState} from "react";
import GeocoderResult = google.maps.GeocoderResult;
import {getQueryParamsFromPlace} from "../../util/AddressUtils";

export const useGeocodeByLatLng = ({latitude, longitude}: {latitude: any, longitude: any}) => {
    const {loading: geocoderLoading, geocoder} = useGeocoder();
    const [geocodedPlace, setGeocodedPlace] = useState<GeocoderResult | undefined>();
    const [geocodingError, setGeocodingError] = useState<any>();

    useEffect(() => {
        if (!geocoderLoading && geocoder?.geocode && latitude != null && longitude != null) {
            geocoder.geocode({ location: new google.maps.LatLng(latitude, longitude) }).then(({ results: places }: google.maps.GeocoderResponse) => {
                if (places?.length) {
                    const topPlace = places[0];
                    const addressParts = getQueryParamsFromPlace(topPlace);
                    if (addressParts?.city && addressParts?.state) {
                        setGeocodedPlace(topPlace);
                        setGeocodingError(false);
                    } else {
                        setGeocodingError(new Error('Geocoding Result has no city or state'));
                    }
                } else {
                    setGeocodingError(new Error('Failed to load place'));
                }
            }).catch((error: any) => {
                console.error(error);
                setGeocodingError(error);
            })
        }
    }, [geocoder, geocoderLoading, latitude, longitude]);

    return {
        geocodedPlace,
        geocodingError
    }
}
